module.exports = __webpack_public_path__ + "img/captrain-logo.5c364b1f.png";